import { createApiRef } from '@backstage/core-plugin-api';

export interface PlatformInfo {
  version?: string;
  license: {
    modules: string[];
    expirationDate: string;
    licensedUsers?: string;
  };
}

export type RequestOptions = {
  token?: string;
};

export interface InfoApi {
  getInfo: (options: RequestOptions) => Promise<PlatformInfo>;
}

export const infoApiRef = createApiRef<InfoApi>({
  id: 'plugin.wb.platform.info.service',
});
